import React, { useState } from "react";
import { Package, Users, Boxes, Eye } from "lucide-react";
import { useApp } from "../../context/AppContext";
import InventoryEmployeesView from "./InventoryEmployees";
import InventoryItemsView from "./InventoryItems";

export default function Inventory() {
    const [tab, setTab] = useState("employees");
    const { hasPermission } = useApp();
    return (
        <div className="page-container !max-w-[1600px]" data-testid="inventory-page">
            <div className="flex items-center gap-3 mb-4 flex-wrap">
                <Package className="w-5 h-5 text-teal-600" />
                <h1 className="text-lg font-bold text-gray-900">Inventaire IT</h1>
                {!hasPermission("inventory:manage") && <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-medium bg-gray-100 text-gray-600" data-testid="inventory-readonly-badge"><Eye className="w-3 h-3" />Lecture seule</span>}
                <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1 ml-2">
                    <button
                        onClick={() => setTab("employees")}
                        className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${tab === "employees" ? "bg-white text-teal-700 shadow-sm" : "text-gray-500 hover:text-gray-700"}`}
                        data-testid="tab-employees">
                        <Users className="w-3.5 h-3.5" />Par employé
                    </button>
                    <button
                        onClick={() => setTab("items")}
                        className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${tab === "items" ? "bg-white text-teal-700 shadow-sm" : "text-gray-500 hover:text-gray-700"}`}
                        data-testid="tab-items">
                        <Boxes className="w-3.5 h-3.5" />Matériel & Stock
                    </button>
                </div>
            </div>
            {tab === "employees" ? <InventoryEmployeesView /> : <InventoryItemsView />}
        </div>
    );
}
